/* Brand logo and display name for every app an agent can use. */

import drive from "./app-logos/drive.svg";
import slack from "./app-logos/slack.svg";
import gmail from "./app-logos/gmail.svg";
import github from "./app-logos/github.svg";
import linear from "./app-logos/linear.svg";
import figma from "./app-logos/figma.svg";
import airtable from "./app-logos/airtable.svg";
import notion from "./app-logos/notion.svg";
import gcalendar from "./app-logos/gcalendar.svg";
import dropbox from "./app-logos/dropbox.svg";
import linkedin from "./app-logos/linkedin.svg";
import whatsapp from "./app-logos/whatsapp.svg";
import teams from "./app-logos/teams.svg";
import discord from "./app-logos/discord.svg";
import telegram from "./app-logos/telegram.svg";

import type { AppId } from "@/shared/types";

// Full-colour brand logos, bundled — source, license and why in app-logos/README.md
export const APP_ICONS: Record<AppId, string> = {
  drive, slack, gmail, github, linear, figma, airtable, notion, gcalendar, dropbox, linkedin, whatsapp, teams, discord, telegram,
};

export const APP_LABEL: Record<AppId, string> = {
  drive: "Google Drive",
  slack: "Slack",
  gmail: "Gmail",
  github: "GitHub",
  linear: "Linear",
  figma: "Figma",
  airtable: "Airtable",
  notion: "Notion",
  gcalendar: "Google Calendar",
  dropbox: "Dropbox",
  linkedin: "LinkedIn",
  whatsapp: "WhatsApp",
  teams: "Microsoft Teams",
  discord: "Discord",
  telegram: "Telegram",
};
